const bgJSON = {
  // General
  Open: 'Отваряне',
  Close: 'Затваряне',
  'Go to next page': 'Следваща страница',
  'Go to previous page': 'Предишна страница',
  'Rows per page': 'Редове на страница',
  of: 'от',
  OR: 'или',
  'Something went wrong': 'Нещо се обърка',
  // Status pages
  "The page you were looking for doesn't exist.":
    'Страницата, която търсите, не съществува',
  "It's on us, we moved the content to a different page. The search below should help!":
    'Преместихме съдържанието на друга страница. Търсенето по-долу трябва да помогне!',
  Search: 'Търсене',
  'Search terms here...': 'Условия за търсене тук ...',
  'Go to homepage': 'Отидете на началната страница',
  'You do not have permission to access this page':
    'Нямате разрешение за достъп до тази страница',
  'Please contact the Compair administrator to give you the appropriate permissions or sign in again with the correct account.':
    'Моля, свържете се с администратора на COMPAIR, за да ви дадете съответните разрешения или да влезете отново с правилния акаунт.',
  'Return to homepage': 'Върнете се на началната страница',
  Unauthorized: 'Неоторизиран',
  // Homepage
  'Together we can achieve clean air for all':
    'Заедно можем да постигнем чист въздух за всички',
  'Join COMPAIR and participate in measuring and reviewing air quality against other city data sources.':
    'Присъединете се към COMPAIR и участвайте в измерването и сравняването на качеството на въздуха спрямо други източници на данни в града',
  'Learn more': 'Научете повече',
  'What We Offer': 'Какво предлагаме',
  'Easy to understand Interactive Dashboards':
    'Лесна за използване интерактивна платформа',
  'A cool new way to visualise and explore potential (urban) solutions quickly and effectively':
    'Модерен нов начин за визуализиране и изследване на потенциални (градски) решения бързо и ефективно',
  'Dynamic Exposure Visualisation Application':
    'Приложение за визуализация на динамичната експозиция',
  'Dynamic Exposure Visualisation':'Визуализация на динамична експозиция',  
  'Dynamic Exposure Visualisation Dashboard': 'Платформа за визуализация на динамична експозиция',
  'Learn how airborne pollutants, including fine dust, vary along routes taken by different modes of travel.': 'Научете как замърсителите във въздуха, включително фин прах, се променят в зависимост от маршрутите и различни начини придвижване.',
  'A better understanding of the local issues in order to be more collaborative and creative in coming up with solutions':
    'По-добро разбиране на местните проблеми, с цел по- добро сътрудничество и креативност при намирането на решения',
  'Try COMPAIR Tools': 'Пробвайте инструментите на COMPAIR ',
  'Making Data More Accessible, click through our offerings and try them for free.':
    'Правим данните по- достъпни, кликнете върху нашите предложения и ги използвайте безплатно',
  'DEVA Application': 'DEVA  приложение',
  'Understand and compare how environmental situations change under different actions':
    'Разберете и сравнете как се променят ситуациите на околната среда при различни действия',
  'See how you can affect your carbon footprint through your daily activities and learn how you can reduce your carbon footprint':
    'Вижте как можете да повлияете върху въглеродния си отпечатък чрез ежедневните си дейности и да научите как можете да го намалите въглеродния си отпечатък',
  'Explore your surroundings via your smartphone or tablet camera, so you can see a visual overlay of environmental information':
    'Изследвайте заобикалящата ви среда чрез камерата на своя смартфон или таблет, за да можете да видите наслагването на информация за околната среда',
  'Lets Be More Aware of Individual Actions and Behaviours':
    'Нека бъдем по-наясно с индивидуалните действия и поведения',
  'Use our dashboards and learn what needs to be done at a personal, local and city-wide level to improve air quality':
    'Използвайте нашите платформи и научете какво трябва да се направи на персонално, местно и градско ниво, за да се подобри качеството на въздуха',
  'Explore results via an easy app and generate ideas for change':
    'Разгледайте резултатите чрез лесно приложение и генерирайте идеи за промяна',
  'Raise awareness about local issues in your community and take part in our experiments':
    'Повишете информираността относно местните проблеми във вашата общност и участвайте в нашите експерименти',
  // Theme settings
  'Theme Settings': 'Настойки на темите',
  'Light mode': 'Светъл режим',
  'Pure Light': 'Светъл фон',
  'Dark mode': 'Тъмен режим',
  'Dark Spaces': 'Тъмен фон',
  // Navigation bar
  'Compair Dashboard': 'Платформа Compair ',
  Admin: 'Администратор',
  User: 'Потребител',
  Guest: 'Гост',
  General: 'Общ',
  Home: 'Начало',
  Dashboards: 'Платформи',
  'Policy Monitoring': 'Мониторинг на политики',
  'Browse the map': 'Разглеждане на картата',
  'Carbon Footprint': 'Въглероден отпечатък',
  Management: 'Управление',
  // User management
  'User Management': 'Управление на потребителите',
  'All aspects related to the app users can be managed from this page':
    'Всички аспекти, свързани с потребителите на приложението, могат да се управляват от тази страница',
  'Create user': 'Създаване на потребител',
  'Add new user': 'Добавяне на нов потребител',
  'Fill in the fields below to create and add a new user to the site':
    'Попълнене полетата по- долу, зада добавите добавите нов потребител в сайта',
  'First name': 'Име',
  'The first name field is required': 'Полето Име е задължително',
  'Last name': 'Фамилия',
  'The last name field is required': 'Полето Фамилия е задължително',
  'Email address': 'Email',
  'The email field is required': 'Полето Email е задължително',
  'The email provided should be a valid email address':
    'Предоставеният Email адрес трябва да е валиден',
  Password: 'Парола',
  'The password field is required': 'Полето Парола е задължително',
  'Must be at least 8 characters': 'Трябва да съдържа поне 8 символа',
  Administrator: 'Администратор',
  Cancel: 'Отказ',
  'All users': 'Всички потребители',
  Administrators: 'Администратори',
  Users: 'Поребители',
  'Search by name, email or username...':
    'Тъсене по име, email или потребителско име ...',
  Name: 'Име',
  Email: 'Email',
  Role: 'Роля',
  'Bulk actions': 'Некоректни действия',
  Delete: 'Изтрийте',
  'Are you sure you want to permanently delete this user account':
    'Сигурни ли сте, че искате да изтриете този потребителски акаунт',
  'The user account has been removed': 'Потребителският акаунт беше премахнат',
  'The user account was created successfully':
    'Потребителският акаунт беше успешно създаден',
  "We couldn't find any users matching your search criteria":
    'Не могат да бъдат намерени потребители, отговарящи на зададените критериите за търсене',
  Edit: 'Редактирай',
  'Update user': 'Актуализиране на потребителя',
  'My Profile': 'Моят профил',
  'Manage informations related to your profile settings':
    'Управление настройките на профила',
  'Personal Details': 'Лични данни',
  'Manage informations related to your personal details':
    'Управление настройките на профила',
  'Update profile': 'Актуализиране на профила',
  'Your profile was updated successfully':
    'Вашият профил беше актуализиран успешно',
  Security: 'Сигурност',
  'Change your security preferences below':
    'Променете своите предпочитания за сигурност по- долу ',
  'Change Password': 'Смяна на парола',
  'You can change your password here': 'Можете да смените своята парола тук',
  'Change password': 'Смяна на парола',
  'Fill in the fields below to change your password':
    'За да смените своята парола, попълнете полетата по- долу',
  'Current password': 'Текуща парола',
  'New password': 'Нова парола',
  'New password is required': 'Изисква се нова парола',
  'Confirm new password': 'Потвърдете новата парола',
  'Confirm password is required': 'Изисква се потвърждение на паролата',
  'Current password is required': 'Изисква се текущата парола',
  'New password must be at least 8 characters':
    'Новата парола трябва да съдържа поне 8 символа',
  'Passwords do not match': 'Паролата не съвпада',
  'Update password': 'Актуализиране на паролата',
  // Top navigation bar
  'My profile': 'Моят профил',
  'Log in to view your details': 'Влезте в своя профил, за да видите детайлите',
  'Language Switcher': 'Промяна на езика',
  // Authentication
  'Sign out': 'Изход',
  'Sign in': 'Вход',
  'Fill in the fields below to sign into your account.':
    'За да влезете в своя акаунт попълнете полетата по- долу',
  'Lost password?': 'Забравена парола?',
  'Username or password is incorrect':
    'Потребителското име или парола са грешни',
  'Don’t have an account, yet?': 'Все още нямате акаунт?',
  'Sign up here': 'Регистрирайте се тук',
  'Recover Password': 'Възстановяване на парола',
  'Enter the email used for registration to reset your password.':
    'Въведете email-а, използван за регистрация, за да възстановите паролата си.',
  'Send me a new password': 'Изпратете ми нова парола',
  'Want to try to sign in again?': 'Искате ли да опитате да влезете отново?',
  'Click here': 'Натиснете тук',
  'Create account': 'Създайте акаунт',
  'Fill in the fields below to sign up for an account.':
    'За да създадете нов акаунт попълнете полетата по- долу',
  'Password must be at least 8 characters':
    'Паролата трябва да съдържа поне 8 символа',
  'Both password need to be the same': 'Двете пароли трябва да съвпадат',
  'You must agree to our terms and conditions':
    'Трябва да се съгласите с правилата и условията',
  'Create your account': 'Създайте своя акаунт',
  'Already have an account?': 'Вече имате акаунт',
  'Sign in here': 'Регистрирайте се тук',
  'You have successfully signed up to Compair. Sign in below to continue':
    'Успешно се регистрирахте в Compair. Влезте, за да продължите',
  'Confirm password': 'Потвърждаване на паролата',
  'I accept the': 'Приемам',
  'terms and conditions': 'Правила и условия',
  // Footer
  'by COMPAIR Project': 'За проекта COMPAIR',
  "This project has received funding from the European Union's Horizon 2020 research and innovation programme under grant agreement No 101036563. This website represents the views of the COMPAIR project only.":
    'Този проект получи финансиране по програмата Horizon 2020 research and innovation на Европейския съюз 2020 по споразумение за безвъзмездна помощ № 101036563. Този уебсайт представлява възгледите само на проекта Compair.',
  'Terms & Conditions': 'Правила и условия',
  'Privacy Policy': 'Политика за поверителност',
};

export default bgJSON;
